"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgCertInnerPattern = function SvgCertInnerPattern(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 284 429"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cert-inner-pattern_svg__a",
    d: "M.28 1h.7v151.97h-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cert-inner-pattern_svg__c",
    d: "M.26.17H139.7V1H.26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cert-inner-pattern_svg__e",
    d: "M1 1h.7v151.97H1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cert-inner-pattern_svg__g",
    d: "M.3.17h139.4V1H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cert-inner-pattern_svg__i",
    d: "M.28.29h.7v151.98h-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cert-inner-pattern_svg__k",
    d: "M.26.26H139.7v.83H.26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cert-inner-pattern_svg__m",
    d: "M1 .29h.7v151.98H1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cert-inner-pattern_svg__o",
    d: "M.3.26h139.4v.83H.3z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(283 275.74)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cert-inner-pattern_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cert-inner-pattern_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#009EE2",
    strokeWidth: 0.28,
    d: "M.78 152.97V.99",
    mask: "url(#cert-inner-pattern_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#009EE2",
    strokeWidth: 0.28,
    d: "m283.77 428.6-8.73-103.04m8.8 103.03-15.95-86.45m15.9 86.41L261.4 352.6m22.34 75.85-26.81-68.35m26.76 68.24L252.47 366m31.3 62.32-36-56.41m35.94 56.4-39.74-51.4m39.8 51.7-44.49-47.16m44.42 47.08-48.67-42.99m48.72 42.94L230.1 390.3m53.58 38.18-59.61-33.4m59.5 33.35-65.98-28.59m65.87 28.55-73.25-23.78m73.28 23.71-82.9-18.03m82.85 18.06-95.36-12.38m95.66 12.6-113.55-6.92"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144 427.74)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cert-inner-pattern_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cert-inner-pattern_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#009EE2",
    strokeWidth: 0.28,
    d: "M139.69.86.26.48",
    mask: "url(#cert-inner-pattern_svg__d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 275.74)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cert-inner-pattern_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cert-inner-pattern_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#009EE2",
    strokeWidth: 0.28,
    d: "M1.2 152.97V.99",
    mask: "url(#cert-inner-pattern_svg__f)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#009EE2",
    strokeWidth: 0.28,
    d: "m1.2 428.6 8.74-103.04m-8.8 103.03 15.95-86.45M1.2 428.55l22.39-75.96M1.24 428.44l26.8-68.35M1.29 428.33 32.52 366m-31.3 62.32 36-56.41M1.27 428.3 41 376.9M1.2 428.6l44.5-47.16M1.29 428.52l48.66-42.99M1.24 428.47l53.63-38.17M1.3 428.48l59.6-33.4M1.42 428.42l65.98-28.59M1.52 428.4l73.25-23.78m-73.28 23.7 82.9-18.03M1.53 428.35l95.36-12.38m-95.66 12.6 113.55-6.92"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 427.74)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cert-inner-pattern_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cert-inner-pattern_svg__g"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#009EE2",
    strokeWidth: 0.28,
    d: "M.3.86 139.7.48",
    mask: "url(#cert-inner-pattern_svg__h)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(283 -.26)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cert-inner-pattern_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cert-inner-pattern_svg__i"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#009EE2",
    strokeWidth: 0.28,
    d: "M.78.3v151.97",
    mask: "url(#cert-inner-pattern_svg__j)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#009EE2",
    strokeWidth: 0.28,
    d: "m283.77.15-8.73 103.03M283.84.15 267.89 86.6M283.78.19 261.4 76.15M283.74.3l-26.81 68.35M283.69.41l-31.23 62.34M283.76.43l-36 56.41M283.7.45l-39.74 51.4M283.76.13 239.28 47.3M283.69.22l-48.67 42.99M283.74.27 230.1 38.44M283.68.26l-59.61 33.4M283.57.32 217.59 28.9M283.46.35l-73.25 23.78M283.49.42l-82.9 18.03M283.44.39l-95.36 12.38M283.74.17 170.19 7.1"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144 -.26)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cert-inner-pattern_svg__l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cert-inner-pattern_svg__k"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#009EE2",
    strokeWidth: 0.28,
    d: "M139.69.4.26.78",
    mask: "url(#cert-inner-pattern_svg__l)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -.26)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cert-inner-pattern_svg__n",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cert-inner-pattern_svg__m"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#009EE2",
    strokeWidth: 0.28,
    d: "M1.2.3v151.97",
    mask: "url(#cert-inner-pattern_svg__n)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#009EE2",
    strokeWidth: 0.28,
    d: "m1.2.15 8.74 103.03M1.14.15 17.09 86.6M1.2.19l22.39 75.96M1.24.3l26.8 68.35M1.29.41l31.24 62.34M1.22.43l36 56.41M1.27.45 41 51.85M1.21.13 45.7 47.3M1.29.22l48.66 42.99M1.24.27l53.63 38.17M1.3.26l59.6 33.4M1.42.32 67.4 28.9M1.52.35l73.25 23.78M1.49.42l82.9 18.03M1.53.39 96.9 12.77M1.24.17 114.8 7.1"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 -.26)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cert-inner-pattern_svg__p",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cert-inner-pattern_svg__o"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#009EE2",
    strokeWidth: 0.28,
    d: "m.3.4 139.4.38",
    mask: "url(#cert-inner-pattern_svg__p)"
  }))));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgCertInnerPattern);
var _default = exports["default"] = Memo;